//#region imports
import React, { useState, useMemo } from 'react';

// redux
import { useSelector } from 'react-redux';
import { selectAltPickupsByTimeSlot } from '_redux/slices/timeline/timeline-data';
import { selectThirtyMinLayout } from "_redux/slices/timeline/timeline-control";
import { selectSelectedTask, selectSelectedTasksList, selectSelectedMultiplePAXTask } from "_redux/slices/timeline/selected-task";
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { selectBookingType } from '_redux/slices/timeline/timeline-areas';

// custom components
import JobCard from '../job-card';

//#endregion

const AltPickupsSection = ({ timeSlot }) => {
    const [clicked, setClicked] = useState([]);

    // Memoize selector to avoid recreating on every render
    const altPickupSelector = useMemo(() => selectAltPickupsByTimeSlot(timeSlot), [timeSlot]);
    const altPickups = useSelector(altPickupSelector);

    const thirtyMinLayout = useSelector(selectThirtyMinLayout);
    const jobsType = useSelector(selectBookingType);
    const selectedTask = useSelector(selectSelectedTask);
    const selectedTasksList = useSelector(selectSelectedTasksList);
    const selectedMultiplePAXTask = useSelector(selectSelectedMultiplePAXTask);
    const usedTheme = useSelector(selectUsedTheme);

    // Don't render if no ALT pickups or filter excludes them
    if (!altPickups || altPickups.length === 0) return null;
    if (!jobsType?.includes("ALTPickUp") && !jobsType?.includes("all")) return null;

    return (
        <div style={{ marginBottom: '4px' }}>
            {/* Header banner */}
            <div style={{
                backgroundColor: 'purple',
                textAlign: 'left',
                padding: '5px',
            }}>
                <span style={{
                    textAlign: 'left',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    padding: 0,
                    margin: 0,
                }}>
                    {timeSlot} Alt Pickups ({altPickups.length})
                </span>
            </div>

            {/* List of ALT pickup jobs - don't modify job object to preserve click selection behavior */}
            <div style={{ padding: '4px', margin: '2px 0' }}>
                {altPickups.map((job, index) => (
                    <JobCard
                        key={job._id || index}
                        job={job}
                        index={index}
                        timelineJobs={true}
                        clicked={clicked}
                        setClicked={setClicked}
                        thirtyMinLayout={thirtyMinLayout}
                        selectedTask={selectedTask}
                        selectedTasksList={selectedTasksList}
                        usedTheme={usedTheme}
                        selectedMultiplePAXTask={selectedMultiplePAXTask}
                        showFullCard={true}
                    />
                ))}
            </div>
        </div>
    );
};

export default React.memo(AltPickupsSection);
